export default __webpack_public_path__ + "static/media/10034845.c5bda42b.mp3";